import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableRow from '@material-ui/core/TableRow'
import Typography from '@material-ui/core/Typography'
import ActionEditFormRightPanel from './form/ActionEditFormRightPanel'
import { SectionsRequestStatus } from 'components/minutetaker/components/form/SelectSectionField'
import minuteTakerSelectors from 'selectors/minuteTakerSelectors'
import actionEditorSelectors from 'selectors/actionEditorSelectors'
import { bindActionCreators } from 'redux'
import { actions as actionEditorReducer } from 'reducers/actionEditorReducer'
import { actions as editorActions } from '../../../reducers/minuteEditorReducer'
import { actions } from '../../../reducers/minuteTakerReducer'
import { actions as actionDashboard } from '../../../reducers/actionDashboardReducer'
import { connect } from 'react-redux'
import { Box, Button, Divider } from '@material-ui/core'
import { translate } from 'components/shared/internationalization'
import {
    AtlasStatusAlert,
    AtlasStatusAlertVar,
    ColorBaseMulberryBlue,
    ColorBaseRichBlack,
    ColorBaseWhite,
    ColorEastBay
} from 'assets/styles/variables'
import { StyledInviteNotificationIcon } from './ActionItemDetailsCard/Atoms'
import NotificationView from '../actionlist/NotificationView'
import { ClassNames } from '@emotion/react'
import { AddActionEditActionButton } from 'components/shared/StyledComponents'
import {
    DeleteButton,
    StyledDeleteActionItemIcon,
    StyledAtlasButton
} from './ActionItemEditDialog/ActionItemEditDialog'
import ConfirmationDialog from 'components/shared/ConfirmationDialog'
import { deleteAction, getActions } from 'businesslayer/api/actions'
import { getSections, normalizeSectionsPayload } from 'businesslayer/api/sections'
import { AtlasIcon } from 'web-components/atlas-icon'
import { EllipseHeading } from 'assets/sharedStyles'
import blockingOperation from 'businesslayer/blockingOperation'
import { ActionData, CurrentMinutesProps, Details, MinutesSectionsData } from 'Types'
import { formatDate } from 'common/formatters/date'
import LinearIndeterminate from 'components/shared/LinearProgress'
import { transientStorageManager } from 'businesslayer/minutesSessionStore'
import { useMinutesManager } from 'pages/minutes-manager-page/use-minutes-manager'
import { useHistory } from 'react-router-dom'
import { handleActionTabNavigation } from 'common/util/utmUtils'
import { REQUEST_STATUS_IDLE } from 'common/constants/constants'
import { canDeleteAction, isUnlinkedAction } from 'common/util/unlinkedActions'
const drawerWidth = 658

const NotificationViewAny = (NotificationView as unknown) as React.ComponentType<any>
const useStyles = makeStyles((theme) => ({
    drawer: {
        maxWidth: drawerWidth,
        [theme.breakpoints.down('md')]: {
            maxWidth: '100vw'
        },
        '@media (max-width: 768px)': {
            width: '100vw'
        }
    },
    drawerPaper: {
        position: 'fixed',
        maxWidth: drawerWidth,
        [theme.breakpoints.down('md')]: {
            maxWidth: '100vw'
        },
        '@media (max-width: 768px)': {
            width: '100vw'
        }
    },
    table: {
        maxWidth: 610,
        margin: 'auto',
        border: '1px solid #E6E6E6',
        [theme.breakpoints.down('md')]: {
            maxWidth: '100%'
        }
    },
    tableCell: {
        border: '1px solid #E6E6E6',
        height: '56px'
    },
    formContainer: {
        width: '100%',
        padding: '24px 24px 10px',
        gap: '0px'
    },
    title: {
        padding: '16px'
    },
    actionsSummary: {
        '&.MuiTypography-body1': {
            padding: '16px',
            fontFamily: 'Source Sans Pro',
            fontWeight: 600,
            fontSize: '22px',
            lineHeight: '26px'
        }
    },
    headerBox: {
        height: '64px',
        backgroundColor: '#fff',
        zIndex: theme.zIndex.drawer + 1,
        flexShrink: 0,
        display: 'flex'
    },
    notificationTitle: {
        color: ColorEastBay,
        fontFamily: 'Source Sans Pro',
        fontWeight: 600,
        fontSize: '22px',
        lineHeight: '26px',
        textAlign: 'center',
        textTransform: 'none'
    },
    btnContainer: {
        float: 'right',
        display: 'flex',
        alignItems: 'center',
        margin: 'auto',
        marginRight: '16px',
        textDecoration: 'none'
    },
    statusClass: {
        color: '#FFFFFF',
        padding: '4px 8px 4px 8px',
        gap: '1px',
        borderRadius: '4px 4px 4px 4px',
        width: 'fit-content',
        fontSize: '12px',
        height: '24px',
        placeContent: 'center',
        textTransform: 'uppercase'
    },
    unlinkedBadgeBox: {
        backgroundColor: '#fff',
        flexShrink: 0,
        padding: '0 16px 12px'
    },
    unlinkedBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        width: 'fit-content',
        maxWidth: '100%',
        padding: '4px 8px',
        borderRadius: '4px',
        border: `1px solid ${AtlasStatusAlert}`,
        backgroundColor: '#FDF3E6',
        color: ColorBaseRichBlack,
        fontFamily: 'Source Sans Pro',
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: '16px',
        textTransform: 'uppercase'
    },
    notificationClass: {
        textTransform: 'capitalize'
    },
    statusClassPending: {
        backgroundColor: '#676767'
    },
    statusClassDue: {
        backgroundColor: 'orange',
        color: '#000000'
    },
    statusClassComplete: {
        backgroundColor: '#05704B'
    },
    btnClass: {
        padding: '8px 12px 8px 12px'
    },
    panal: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    },
    footer: {
        height: '72px',
        backgroundColor: '#fff',
        zIndex: theme.zIndex.drawer + 1,
        flexShrink: 0
    },
    body: {
        flexGrow: 1,
        overflowY: 'auto'
    },
    footerComp: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        padding: theme.spacing(2),
        gap: '16px'
    },
    backButton: {
        backgroundColor: '#2f3b4d',
        color: '#fff',
        border: 'none',
        cursor: 'pointer',
        outline: 'none',
        margin: 'auto',
        marginRight: '8px',
        width: '40px',
        height: '40px',
        '&:focus, &:active': {
            outline: 'none',
            width: '40px',
            height: '40px',
            boxShadow: `0px 0px 0px 1px ${ColorBaseWhite}, 0px 0px 0px 3px ${ColorBaseMulberryBlue}`,
            borderRadius: '2px'
        }
    },
    padHeader: {
        backgroundColor: '#2f3b4d',
        width: '100%',
        display: 'none',
        height: '64px',
        [theme.breakpoints.down('md')]: {
            display: 'flex'
        }
    },
    headerCenterLogo: {
        flex: '1 0 0',
        color: 'var(--core-color-legacy-white, #fff)',
        textAlign: 'center',
        fontFamily: 'source sans pro',
        font: ' 600 18px/24px Source Sans Pro',
        placeSelf: 'center'
    },
    sendNotification: {
        '&:focus, &:active': {
            outline: 'none',
            boxShadow: `0px 0px 0px 1px ${ColorBaseWhite}, 0px 0px 0px 3px ${ColorBaseMulberryBlue}`,
            borderRadius: '2px'
        },
        '& span': {
            gap: '8px'
        }
    }
}))

interface RightDrawerProps {
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
    isOpen: boolean
    selectedAction: Details | null
    setSelectedAction: React.Dispatch<React.SetStateAction<Details | null>>
    prefetchedSections?: Array<{ id: string | number; name: string; sectionType?: string }>
    /** When set (e.g. Action Dashboard), fetch lifecycle is explicit; empty list after success is not "still loading". */
    prefetchedSectionsRequestStatus?: SectionsRequestStatus
    allContacts: Array<any>
    dateInputMask: string
    sections: Array<MinutesSectionsData>
    selectedSection: any
    actions: {
        loadActionsFulfilled: (...args: any) => void
        updateTakerListAction: (...args: any) => void
        resetEditedAction: (...args: any) => void
        removeAction: (id: string) => void
        saveExistingAction: (params: ActionData) => void
        loadContacts: () => void
        loadSections?: (payload: any) => void
        deleteDashboardAction: (...args: any) => void
        editActionDashboardFullfilled: (...args: any) => void
        actionItemSaved: () => void
    }
    saveComplete: any
    currentMinuteItem: CurrentMinutesProps
    savedAction: any
    dateFormat: string
    minutesActions: any
    handleNotificationStatusChange?: (...args: any) => void
}

const RightDrawer: React.FC<RightDrawerProps> = ({
    setIsOpen,
    isOpen,
    selectedAction = {
        committee_id: '',
        completed_date: null,
        status: '',
        id: '',
        notificationStatus: ''
    } as Details,
    setSelectedAction,
    prefetchedSections,
    prefetchedSectionsRequestStatus,
    allContacts,
    sections,
    selectedSection,
    dateInputMask,
    actions,
    saveComplete,
    currentMinuteItem,
    savedAction,
    minutesActions,
    handleNotificationStatusChange
}) => {
    const classes = useStyles()
    const { isAdminOfCommittee } = useMinutesManager()
    const isAdmin = isAdminOfCommittee(selectedAction?.committee_id ?? '')
    /*
     * Allow deleting unlinked actions: when the Unlinked Actions feature is on and
     * the action belongs to a committee no longer visible to the user, the delete
     * button is shown even though the user isn't an admin of that committee.
     */
    const canDelete = canDeleteAction(selectedAction, isAdmin)
    const [open, setOpen] = useState(false)
    const [showConfirmation, setShowConfirmation] = useState(false)
    const [showSaveButton, setShowSaveButton] = useState(false)
    const [showIndicator, setShowIndicator] = useState(null)
    const [hasReminders, setHasReminders] = useState(false)
    const [localSections, setLocalSections] = useState<
        Array<{ id: string | number; name: string; sectionType?: string }>
    >([])
    const [localSectionsRequestStatus, setLocalSectionsRequestStatus] = useState<
        SectionsRequestStatus
    >('idle')
    const history = useHistory()
    const drawerRef = useRef<HTMLDivElement>(null)
    const toggleDrawer = useCallback(
        () => {
            setIsOpen(false)
            setSelectedAction(null)
            handleActionTabNavigation(history)
        },
        //eslint-disable-next-line react-hooks/exhaustive-deps
        [setIsOpen, setSelectedAction, history]
    )
    useEffect(() => {
        if (!allContacts) actions.loadContacts()
    }, [actions, allContacts])

    // When drawer opens with empty sections, fetch and keep sections in local state (Redux may be empty on Actions tab). Skip fetch if parent prefetched sections (e.g. Action Dashboard).
    const minutesIdForSections =
        currentMinuteItem?.id ?? selectedAction?.minutes_document_id ?? selectedAction?.minutesId

    const dashboardOwnsPrefetch = prefetchedSectionsRequestStatus !== undefined
    const dashboardPrefetchActive =
        dashboardOwnsPrefetch && prefetchedSectionsRequestStatus !== REQUEST_STATUS_IDLE

    const effectiveSections: MinutesSectionsData[] = dashboardPrefetchActive
        ? ((prefetchedSections ?? []) as MinutesSectionsData[])
        : (prefetchedSections?.length ?? 0) > 0
        ? (prefetchedSections as MinutesSectionsData[])
        : sections?.length
        ? Array.isArray(sections)
            ? sections
            : (Object.values(sections) as MinutesSectionsData[])
        : (localSections as MinutesSectionsData[])

    const sectionsRequestStatusForSelect = useMemo((): SectionsRequestStatus | undefined => {
        if (effectiveSections.length > 0) {
            return 'success'
        }
        if (dashboardPrefetchActive) {
            return prefetchedSectionsRequestStatus
        }
        return localSectionsRequestStatus
    }, [
        effectiveSections.length,
        dashboardPrefetchActive,
        prefetchedSectionsRequestStatus,
        localSectionsRequestStatus
    ])

    useEffect(() => {
        if (!isOpen || !minutesIdForSections) {
            setLocalSections([])
            setLocalSectionsRequestStatus('idle')
            return
        }
        // Action Dashboard already fetched or is fetching — do not duplicate getSections.
        if (dashboardPrefetchActive) {
            setLocalSections([])
            setLocalSectionsRequestStatus('idle')
            return
        }
        const hasSections =
            (prefetchedSections?.length ?? 0) > 0 || (sections && sections.length > 0)
        if (hasSections) {
            setLocalSections([])
            setLocalSectionsRequestStatus('idle')
            return
        }
        setLocalSectionsRequestStatus('loading')
        getSections(minutesIdForSections)
            .then((payload) => {
                setLocalSections(normalizeSectionsPayload(payload))
                setLocalSectionsRequestStatus('success')
                if (actions.loadSections) {
                    const toSend = Array.isArray(payload) ? { minutesSections: payload } : payload
                    actions.loadSections(toSend)
                }
            })
            .catch(() => {
                setLocalSections([])
                setLocalSectionsRequestStatus('error')
            })
    }, [
        isOpen,
        minutesIdForSections,
        dashboardPrefetchActive,
        prefetchedSections,
        sections,
        actions
    ])

    useEffect(() => {
        const actionWithReminders = selectedAction as any
        const hasExistingReminders =
            actionWithReminders?.reminders && actionWithReminders.reminders.length > 0
        setHasReminders(hasExistingReminders)
    }, [selectedAction])

    const completed_date = selectedAction?.completed_date ?? null
    const status = selectedAction?.status ?? ''
    const id = selectedAction?.id ?? ''

    const { dateFormat } = transientStorageManager
    const date = completed_date
        ? formatDate({ date: completed_date, dateFormat: dateFormat })
        : translate('NO_DUE_DATE')
    const getDatefnsFormat = useCallback((dateFormat) => {
        return dateFormat.replace(/[DY]/g, function (c: string) {
            return c.toLowerCase()
        })
    }, [])
    useEffect(() => {
        if (saveComplete && savedAction) {
            const existing =
                minutesActions?.find((a) => String(a?.id) === String(savedAction?.id)) ?? {}
            const sectionId =
                savedAction?.minutesSectionId ??
                savedAction?.minutes_section_id ??
                existing?.minutesSectionId ??
                existing?.minutes_section_id
            const match =
                sectionId != null && sectionId !== ''
                    ? effectiveSections?.find((s) => String(s?.id) === String(sectionId))
                    : undefined

            actions.updateTakerListAction({
                ...existing,
                ...savedAction,
                ...(sectionId != null && sectionId !== ''
                    ? { minutes_section_id: sectionId, minutesSectionId: sectionId }
                    : {}),
                ...(match?.name ? { section_name: match.name } : {})
            })
            actions.resetEditedAction()
            setIsOpen(false)
            actions.actionItemSaved()
            setSelectedAction(null)
        }
        // Intentionally omit minutesActions / effectiveSections: including them re-runs this effect
        // after updateTakerListAction updates Redux while saveComplete + savedAction are still true → loop.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [actions, saveComplete, savedAction, setIsOpen, setSelectedAction])

    const onCloseNotificationView = useCallback(() => setOpen(false), [])
    const handleOpenNotification = useCallback(() => setOpen(true), [])
    const handleSendNotification = useCallback(
        (args) => {
            handleNotificationStatusChange?.(args)
        },
        [handleNotificationStatusChange]
    )
    const reloadActions = useCallback(async () => {
        if (currentMinuteItem?.id) {
            const data = await getActions(currentMinuteItem.id)
            actions.loadActionsFulfilled(data)
        }
        onCloseNotificationView()
    }, [actions, currentMinuteItem, onCloseNotificationView])
    const handleSaveButtonClick = useCallback(() => {
        const form = document.getElementById('editActionsForm')
        if (form) {
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))
        }
    }, [])

    const handleFormValuesChange = useCallback((values: any) => {
        const remindersExist = values.reminders && values.reminders.length > 0
        setHasReminders(remindersExist)
    }, [])

    //Delete function
    const handleDeleteAction = useCallback(
        async () => {
            setShowConfirmation(false)
            setIsOpen(false)
            blockingOperation.showProgress(null, true)
            const minutesId = currentMinuteItem?.id ?? selectedAction?.minutes_document_id
            await deleteAction(
                minutesId,
                id,
                deleteAction.bind(null, currentMinuteItem?.id ?? minutesId, id, selectedAction),
                selectedAction
            )
            if (!currentMinuteItem) {
                actions.deleteDashboardAction(selectedAction?.id!)
            } else {
                actions.removeAction(selectedAction?.id!)
                reloadActions()
            }
            handleActionTabNavigation(history)
            blockingOperation.hideProgress()
        },
        //eslint-disable-next-line react-hooks/exhaustive-deps
        [actions, currentMinuteItem, id, selectedAction, reloadActions, setIsOpen]
    )

    const notificationStatus = useCallback(() => {
        const currentAction =
            !!minutesActions &&
            minutesActions.length &&
            minutesActions.filter((value) => {
                return value.id === selectedAction?.id
            })
        return (
            (!!currentAction && currentAction.length && currentAction[0].notificationStatus) ||
            selectedAction?.notificationStatus
        )
    }, [minutesActions, selectedAction])

    const renderConfirmedAction = useMemo(
        () => (
            <ConfirmationDialog
                message={(translate('DELETE_ACTION_MESSAGE') as unknown) as string}
                title={(translate('DELETE_ACTION_TITLE') as unknown) as string}
                onConfirm={handleDeleteAction}
                onCancel={() => setShowConfirmation(false)}
                confirmLabel={(translate('DELETE') as unknown) as string}
            />
        ),
        [handleDeleteAction, setShowConfirmation]
    )
    const handleonActionItemSubmit = useCallback(
        async (action) => {
            blockingOperation.showProgress(null, true)
            const data = (await actions.saveExistingAction(action)) as any
            const payload = data?.value
            try {
                const actionItems = payload?.actionItems
                const key = actionItems ? Object.keys(actionItems)[0] : undefined
                const attrs = key ? actionItems?.[key]?.attributes : undefined
                const sectionId =
                    action?.minutesSectionId ??
                    action?.minutes_section_id ??
                    attrs?.minutesSectionId ??
                    attrs?.minutes_section_id

                if (key && attrs && (attrs.section_name == null || attrs.section_name === '')) {
                    const match = effectiveSections?.find(
                        (s: any) => String(s?.id) === String(sectionId)
                    )
                    if (match?.name) {
                        // Mutate a shallow-cloned payload to avoid accidental shared references.
                        const nextPayload = {
                            ...payload,
                            actionItems: {
                                ...actionItems,
                                [key]: {
                                    ...actionItems[key],
                                    attributes: {
                                        ...attrs,
                                        section_name: match.name
                                    }
                                }
                            }
                        }
                        actions.editActionDashboardFullfilled(nextPayload)
                        blockingOperation.hideProgress()
                        return
                    }
                }
            } catch {
                // fall through to dispatch raw payload
            }

            actions.editActionDashboardFullfilled(payload)
            blockingOperation.hideProgress()
        },
        [actions, effectiveSections]
    )
    const confirmationDialog = showConfirmation ? renderConfirmedAction : null
    const statusClass = useMemo(() => {
        switch (status) {
            case 'complete':
                return classes.statusClassComplete
            case 'overdue':
                return classes.statusClassDue
            default:
                return classes.statusClassPending
        }
    }, [status, classes])

    useEffect(() => {
        const handleOutsideClick = (event: MouseEvent) => {
            const target = event.target as HTMLElement
            if (target.closest('[role="dialog"]')) {
                return
            }
            if (
                target.closest(
                    '.react-select__menu, .react-select__menu-list, .react-select__option, .react-select__control, .react-select__value-container, .react-select__multi-value, .react-select__indicators, .react-select__input-container, .react-select__menu-portal, .react-select__menu-outer, .react-select__menu-inner'
                )
            ) {
                event.stopPropagation()
                return
            }

            if (
                target.closest(
                    '.MuiDialog-root, .MuiDialog-container, .MuiDialog-paper, .MuiDialogContent-root, .MuiDialogActions-root'
                )
            ) {
                event.stopPropagation()
                return
            }

            const drawerContent = document.querySelector(`.${classes.drawerPaper}`)
            if (drawerContent?.contains(target)) {
                return
            }

            if (target.closest('.MuiPopover-root, .MuiModal-root, .MuiPopper-root')) {
                return
            }

            if (
                target.closest(
                    '.date-picker-calendar, #date-picker-modal-id, .date-picker-input, .date-picker-container'
                )
            ) {
                return
            }

            setIsOpen(false)
            setSelectedAction(null)
            handleActionTabNavigation(history)
        }

        const addEventListener = () => {
            if (isOpen) {
                document.addEventListener('mousedown', handleOutsideClick, true)
            }
        }

        const removeEventListener = () => {
            document.removeEventListener('mousedown', handleOutsideClick, true)
        }

        addEventListener()

        return () => {
            removeEventListener()
        }
    }, [isOpen, classes.drawerPaper, setIsOpen, setSelectedAction, history])

    return (
        <Drawer
            className={classes.drawer}
            classes={{ paper: classes.drawerPaper }}
            anchor="right"
            open={isOpen}
            onClose={toggleDrawer}>
            <div className={classes.panal} ref={drawerRef}>
                <Box className={classes.padHeader}>
                    <button onClick={toggleDrawer} className={classes.backButton}>
                        <AtlasIcon
                            name="expand-left"
                            size={30}
                            color="--background-base"
                            data-rh={translate('BACK_TO_MINUTES_MANAGER')}
                        />
                    </button>
                    <EllipseHeading className={classes.headerCenterLogo}>
                        {translate('WINDOW_TITLE')}
                    </EllipseHeading>
                </Box>
                <Box className={classes.headerBox}>
                    <Typography className={classes.actionsSummary}>
                        {translate('ACTION_SUMMARY')}
                    </Typography>
                    <Box className={classes.btnContainer}>
                        {isAdmin && (
                            <Button
                                disabled={!isAdmin}
                                disableFocusRipple
                                disableRipple
                                className={classes.sendNotification}
                                data-analytics="MM-SendNotification"
                                onClick={handleOpenNotification}>
                                <StyledInviteNotificationIcon
                                    isActive={false}
                                    skeleton={true}
                                    fill={ColorEastBay}
                                />
                                <Typography className={classes.notificationTitle}>
                                    {translate('SEND_NOTIFICATION_TITLE')}
                                </Typography>
                            </Button>
                        )}
                    </Box>
                </Box>

                {isUnlinkedAction(selectedAction) && (
                    <Box className={classes.unlinkedBadgeBox}>
                        <Box className={classes.unlinkedBadge} role="status">
                            <AtlasIcon name="status-alert" size={16} color={AtlasStatusAlertVar} />
                            {translate('UNLINKED_ACTION_BADGE')}
                        </Box>
                    </Box>
                )}
                <Divider />
                {<LinearIndeterminate loading={showIndicator} />}
                <Box className={classes.body}>
                    <TableContainer className={classes.title}>
                        <Table className={classes.table} aria-label="details table">
                            <TableBody>
                                <TableRow>
                                    <TableCell className={classes.tableCell}>
                                        {translate('ACTION_ITEM_STATUS')}
                                    </TableCell>
                                    <TableCell className={classes.tableCell}>
                                        <Box className={`${classes.statusClass} ${statusClass}`}>
                                            {status}
                                        </Box>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.tableCell}>
                                        {translate('COMPLETED_DATE')}
                                    </TableCell>
                                    <TableCell className={classes.tableCell}>{date}</TableCell>
                                </TableRow>
                                {isAdmin && (
                                    <TableRow>
                                        <TableCell className={classes.tableCell}>
                                            {translate('NOTIFICATION')}
                                        </TableCell>
                                        <TableCell
                                            className={`${classes.tableCell} ${classes.notificationClass}`}>
                                            {notificationStatus()}
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {open && (
                        <NotificationViewAny
                            action={selectedAction}
                            minutesItem={currentMinuteItem}
                            onClose={onCloseNotificationView}
                            onSaved={handleSendNotification}
                            reloadActions={reloadActions}
                            setIndicator={setShowIndicator}
                        />
                    )}
                    <div className={classes.formContainer}>
                        <ActionEditFormRightPanel
                            action={selectedAction ?? {}}
                            allContacts={allContacts}
                            dateInputMask={getDatefnsFormat(dateInputMask)}
                            sections={effectiveSections}
                            sectionsRequestStatus={sectionsRequestStatusForSelect}
                            selectedSection={selectedSection}
                            onActionItemSubmit={handleonActionItemSubmit}
                            currentMinuteItem={currentMinuteItem}
                            isAdmin={isAdmin}
                            setShowSaveButton={setShowSaveButton}
                            actions={actions}
                            setIsOpen={setIsOpen}
                            setSelectedAction={setSelectedAction}
                            history={history}
                            onFormValuesChange={handleFormValuesChange}
                        />
                    </div>
                </Box>
                <Divider />
                <Box className={classes.footer}>
                    <Box className={classes.footerComp}>
                        {canDelete && (
                            <ClassNames key="actionDeleteCss">
                                {({ css }) => (
                                    <button
                                        disabled={!canDelete}
                                        key="actionDelete"
                                        data-analytics="MM-DeleteAction"
                                        className={`${css`
                                            ${DeleteButton}
                                        `} ${classes.btnClass} `}
                                        onClick={() => setShowConfirmation(true)}>
                                        {<StyledDeleteActionItemIcon />}
                                        {translate('DELETE_ACTION_CTA')}
                                    </button>
                                )}
                            </ClassNames>
                        )}
                        <AddActionEditActionButton
                            key="actionCancel"
                            disableFocusRipple
                            disableRipple
                            disabled={false}
                            onClick={toggleDrawer}>
                            {translate('CANCEL')}
                        </AddActionEditActionButton>
                        <StyledAtlasButton
                            key="actionSave"
                            disabled={!showSaveButton}
                            type="submit"
                            onClick={handleSaveButtonClick}
                            disableRipple
                            disableFocusRipple
                            {...(hasReminders && { 'data-analytics': 'MM-Reminder-fields' })}>
                            {translate('SAVE')}
                        </StyledAtlasButton>
                    </Box>
                </Box>
                {confirmationDialog}
            </div>
        </Drawer>
    )
}
const mapStateToProps = (state, _) => {
    return {
        sections: minuteTakerSelectors.minutesSections(state.minuteTakerReducer),
        currentMinuteItem: minuteTakerSelectors.currentMinuteItem(state.minuteTakerReducer),
        selectedSection: minuteTakerSelectors.selectedSection(state.minuteTakerReducer),
        editedAction: minuteTakerSelectors.editedAction(state.minuteTakerReducer),
        block: minuteTakerSelectors.editedBlock(state.minuteTakerReducer),
        allContacts: actionEditorSelectors.allContacts(state.actionEditorReducer),
        readyToSave: actionEditorSelectors.readyToSave(state.actionEditorReducer),
        saveComplete: actionEditorSelectors.saveComplete(state.actionEditorReducer),
        savedAction: actionEditorSelectors.savedAction(state.actionEditorReducer),
        dateFormat: actionEditorSelectors.dateFormat(state.actionEditorReducer),
        dateInputMask: actionEditorSelectors.dateInputMask(state.actionEditorReducer),
        minutesActions: minuteTakerSelectors.minutesActions(state.minuteTakerReducer)
    }
}

const mapDispatchToProps = (dispatch) => {
    const {
        removeAction,
        resetEditedAction,
        updateTakerListAction,
        saveExistingAction,
        editSectionAction,
        loadActionsFulfilled,
        loadSections,
        loadContacts,
        deleteDashboardAction,
        editActionDashboardFullfilled,
        actionItemSaved
    } = { ...actions, ...editorActions, ...actionEditorReducer, ...actionDashboard }

    return {
        actions: bindActionCreators(
            {
                removeAction,
                resetEditedAction,
                updateTakerListAction,
                saveExistingAction,
                editSectionAction,
                loadActionsFulfilled,
                loadSections,
                loadContacts,
                deleteDashboardAction,
                editActionDashboardFullfilled,
                actionItemSaved
            },
            dispatch
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RightDrawer)
